module.exports = __webpack_public_path__ + "img/anewitem-noimage.27267b94.jpg";